<template>
  <div class="control_bar control_bar_messageHistory top">
    <div class="search_wrapper">
      <div class="search">
        <input
          type="text"
          class="search_field"
          placeholder="ユーザID、名前から検索"
          v-model="inputValue"
        />
        <input
          type="button"
          :value="search"
          class="search_button"
          @click="messageHistoryFindAction"
        />
      </div>
    </div>

    <div class="controller_dummy"></div>
    <div class="modal_window" v-if="showFinishModal">
      <finishModalWindow :question="finishWord" @close="close">
      </finishModalWindow>
    </div>
    <div class="modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import finishModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      inputValue: '',
      search: '検索',
      showFinishModal: false,
      finishWord: '',
      showloadingModal: false
    }
  },
  computed: {},
  components: {
    finishModalWindow,
    loadingModalWindow
  },
  methods: {
    close(e) {
      this.showFinishModal = false
    },
    closeModal(e) {
      this.showFinishModal = false
    },
    messageHistoryFindAction(event) {
      this.$emit('input-event', 0, this.inputValue)
    }
  }
}
</script>

<style scoped>
.search_wrapper {
  display: table-cell;
  width: 60%;
}
.search {
  margin: auto 0;
  height: 55px;
}
.controller_dummy {
  display: table-cell;
  width: 40%;
}
.control_bar_messageHistory {
  width: 100%;
  height: 55px;
  background-color: #daf8f3;
  border-bottom: 1px solid #808080;
  display: table;
  table-layout: fixed;
}
</style>



// WEBPACK FOOTER //
// src/components/messageHistory/controlbar.vue